import FirebaseContext, { withFirebase } from './context';
import * as collections from './collections';
import Firebase from './Firebase';

export default Firebase;

export { FirebaseContext, withFirebase, collections };
